'use client';

import {PropsWithChildren, useEffect, useState} from 'react';

import {useOmicronABFlag} from '@web-catalog/hooks';

import {authDoneStates, useAuthProgressState} from '@web-catalog/store/auth';

import {safeLocalStorage} from '@web-catalog/utils/safeStorages';

import {AUTH_SHOWN_STORAGE_KEY} from '../consts';

type Props = {
  /** if true, doesn't block waiting for auth in current session if auth was already shown in past */
  passIfAuthWasEverDone?: boolean;
};

/* renders children if auth is disabled of finished */
export const AuthDoneGate = ({
  children,
  passIfAuthWasEverDone = false,
}: PropsWithChildren<Props>) => {
  const autologinEnabled = useOmicronABFlag('WEB_AUTO_LOGIN') !== 'none';
  const authProgressState = useAuthProgressState();
  const [authWasAlreadyShown, setAuthWasAlreadyShown] = useState(false);

  useEffect(() => {
    if (safeLocalStorage.getItem(AUTH_SHOWN_STORAGE_KEY)) {
      setAuthWasAlreadyShown(true);
    }
  }, []);

  if (
    !autologinEnabled ||
    (passIfAuthWasEverDone && authWasAlreadyShown) ||
    authDoneStates.includes(authProgressState)
  ) {
    return children;
  }

  return null;
};
